import type {
  RefereeAnswer,
  RefereeAnswerRequest,
  RefereeQuestionForReferee,
} from '../types/referee-app.types';

export function buildAnswers(answers: RefereeAnswer[]): Record<string, string> {
  return Object.fromEntries(answers.map((a) => [a.questionId, a.answerText]));
}

export function validate(
  questions: RefereeQuestionForReferee[],
  answers: Record<string, string>
): Record<string, string | undefined> {
  const errs: Record<string, string | undefined> = {};
  for (const q of questions) {
    if (q.isRequired && !answers[q.id]?.trim()) errs[q.id] = 'This answer is required';
  }
  return errs;
}

export function toPayload(answers: Record<string, string>): RefereeAnswerRequest[] {
  return Object.entries(answers).map(([questionId, answerText]) => ({ questionId, answerText }));
}
